import React from 'react';
import { BRAND } from '../../utils/brand';

function BrandMark({ size = 'md', label = BRAND.name }) {
  const sizes = {
    sm: 'h-10 w-10 rounded-xl',
    md: 'h-12 w-12 rounded-2xl',
    lg: 'h-14 w-14 rounded-2xl',
  };

  return (
    <div
      className={`relative flex shrink-0 items-center justify-center bg-neutral-800 shadow-sm ring-1 ring-black/5 dark:bg-neutral-100 ${sizes[size] || sizes.md}`}
      aria-label={label}
      title={label}
    >
      <img src={BRAND.logoSrc} alt="" className="h-4/5 w-4/5" />
    </div>
  );
}

export default BrandMark;
